module.exports = __webpack_public_path__ + "static/images/event/software-update-urgent-3.png";